import client from './client';

export interface AdminRecoveryIdentity {
  loginId: string;
  bizNumber: string;
  phone: string;
}

export async function requestPasswordOtp(
  identity: AdminRecoveryIdentity,
): Promise<{ maskedPhone: string }> {
  const res = await client.post<{ maskedPhone: string }>(
    '/api/password-recovery/admin/request-otp',
    identity,
  );
  return res.data;
}

export async function verifyPasswordOtp(
  identity: AdminRecoveryIdentity,
  otp: string,
  newPassword: string,
): Promise<{ success: true }> {
  const res = await client.post<{ success: true }>(
    '/api/password-recovery/admin/verify-otp',
    { ...identity, otp, newPassword },
  );
  return res.data;
}
